module.exports = __webpack_public_path__ + "img/w16-b3.4cd13fb5.jpg";